/* CAVE — make links like /products/caviar-bundle#cave-order land on that section.
   Horizon may scroll an inner container (.page-wrapper) rather than the window,
   and layout can still shift while images and fonts load, so after load this
   puts the visitor on the requested section once — unless they have already
   started scrolling themselves. scrollIntoView works with any scroller. */
(() => {
  const id = location.hash.length > 1 ? decodeURIComponent(location.hash.slice(1)) : '';
  if (!id) return;
  let cancelled = false;
  const land = () => {
    if (cancelled) return;
    const el = document.getElementById(id);
    if (el && Math.abs(el.getBoundingClientRect().top) > 120) el.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  const start = () => { land(); setTimeout(land, 700); setTimeout(land, 1600); };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
  ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach((type) =>
    addEventListener(type, () => { cancelled = true; }, { once: true, passive: true, capture: true })
  );
})();
